import http from './httpService';
import {encodeQueryData} from './../../Utils/Common';
const API_URL_FINANCIAL = process.env.REACT_APP_API_URL_FINANCIAL;
const API_URL_TARGET = process.env.REACT_APP_API_URL_TARGET;


async function getLineChartData(params:any) {
    const url = `${API_URL_FINANCIAL}get_line_chart?`+encodeQueryData(params);
    let response = await http.get(url);
    return response;
}

async function getBarChartData(params:any) {
    const url = `${API_URL_FINANCIAL}get_bar_chart?`+encodeQueryData(params);
    let response = await http.get(url);
    return response;
}

async function getCustomersData(params:any) {
    const url = `${API_URL_TARGET}getAllCustomers?`+encodeQueryData(params);
    let response = await http.get(url);
    return response;
}

async function getTreeData(params:any) {
    const url = `${API_URL_FINANCIAL}get_heirarchy_chart?`+encodeQueryData(params);
    let response = await http.get(url);
    return response;
}

const FinancialAnalysisSerices = {
    getLineChartData,
    getBarChartData,
    getCustomersData,
    getTreeData,
};

export default FinancialAnalysisSerices;
